import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useCreateGroupMutation } from '../../../generated/graphql';
import { FormField, FormTextArea } from '../../form';
import styles from './NewGroupDialog.module.css';

type NewGroupDialogProps = {
    onClose: () => void,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewGroupDialog = (props: NewGroupDialogProps) => {
    const { style, visible, onClose } = props;
    const [createGroup, createGroupResult] = useCreateGroupMutation();
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [validationError, setValidationError] = useState('');

    const handleSubmit = () => {
        if (!name || !description) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        setValidationError('');
        createGroup({
            variables: {
                group: { name, description }
            }
        })
            .then(() => onClose())
            .catch(() => {});
    };

    return (
        <DialogBase
            isLoading={createGroupResult.loading}
            title="New Group"
            type='OkCancel'
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            visible={visible}
            className={styles.NewGroupDialog}
            style={style}
            data-testid="NewGroupDialog">
            <FormField label="Name" name="name" value={name} onChange={setName} />
            <FormTextArea label="Description" name="description" value={description} onChange={setDescription} />
        </DialogBase>
    );
};

export default NewGroupDialog;